module.exports = __webpack_public_path__ + "media/btnChange.391db6f6.mp3";